// LOAD CUSTOM CSS
// -----------------------------------

import $ from 'jquery';

function initLoadCSS() {

  $('[data-load-css]').on('click', function(e) {

    var element = $(this);

    if (element.is('a'))
      e.preventDefault();

    var uri = element.data('loadCss'),
      link;

    if (uri) {
      link = createLink(uri);
      if (!link) {
        $.error('Error creating stylesheet link element.');
      }
    } else {
      $.error('No stylesheet location defined.');
    }
  });
  
  var theme_no = getCookie('p_system_theme');
  // console.log('theme_no: ' + theme_no);
  if (theme_no != '') {
    $('input[name="setting-theme"][value='+ theme_no +']').click();
  } else {
    $('input[name="setting-theme"]:checked').click();
  }
}

function createLink(uri) {
  var linkId = 'autoloaded-stylesheet',
    oldLink = $('#' + linkId).attr('id', linkId + '-old');

  $('head').append($('<link/>').attr({
    'id': linkId,
    'rel': 'stylesheet',
    'href': uri
  }));

  if (oldLink.length) {
    // delay removal of previous stylesheet to avoid some flickering
    setTimeout(function() {
      oldLink.remove();
    }, 300);
  }

  return $('#' + linkId);
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
  let c = ca[i];
  while (c.charAt(0) == ' ') {
    c = c.substring(1);
  }
  if (c.indexOf(name) == 0) {
    return c.substring(name.length, c.length);
  }
  }
  return "";
}

export default initLoadCSS;
